<script>
import { Helper } from '@/mixin/helper'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header'
import { UPDATE_SENSOR_PAGINATED } from '@/services/api/setting/sensor'
import { GET_SENSOR } from '@/services/api/fleetConfiguration'
import McButton from '@/components/McButton'

export default {
  components: {
    Layout,
    PageHeader,
    McButton,
  },
  mixins: [Helper],
  apollo: {
    sensor: {
      fetchPolicy: 'no-cache',
      query: GET_SENSOR,
      variables() {
        return {
          filter: {
            pinCode: this.pinCode,
            sensorCode: this.sensorCode,
            vehicleId: this.vehicleId,
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const result = data.sensor.sensor
          this.data.vehicleId = result.vehicleId
          this.data.licensePlate = result.vehicle?.licensePlate ?? '-'
          this.data.vgroups = result.vehicleGroup?.map((item) => item.name).join(', ') ?? '-'
          this.data.fleetCategory = result.vehicleType?.category ?? '-'
          this.data.fleetType = result.vehicleType?.type ?? '-'
          this.data.sensorType = 'Sensor Bahan Bakar'
          this.form.alertHi = result.alertHi
          this.form.alertLo = Math.abs(result.alertLo)
          this.current.alertHi = result.alertHi
          this.current.alertLo = Math.abs(result.alertLo)
          this.form.rangeHi = result.rangeHi
          this.form.rangeLo = result.rangeLo
          this.form.fuelCapacity = result.vehicle?.fuelCapacity ?? 0
        }
      },
    },
  },
  props: {
    status: String,
  },
  data() {
    return {
      data: {
        vehicleId: 0,
        licensePlate: '-',
        vgroups: '-',
        fleetCategory: '-',
        fleetType: '-',
        sensorType: '-',
      },
      form: {
        alertHi: 7,
        alertLo: 7,
        rangeHi: 0,
        rangeLo: 0,
        fuelCapacity: 0,
      },
      current: {
        alertHi: 0,
        alertLo: 0,
      },
      isUpdated: false,
    }
  },
  computed: {
    alertHiLiter() {
      return Number(((this.form.alertHi / 100) * this.form.fuelCapacity).toFixed(2))
    },
    alertLoLiter() {
      return Number(((this.form.alertLo / 100) * this.form.fuelCapacity).toFixed(2))
    },
    pinCode() {
      const arrId = this.$route.params.id.split('-')
      return Number(arrId[2])
    },
    sensorCode() {
      const arrId = this.$route.params.id.split('-')
      return Number(arrId[1])
    },
    vehicleId() {
      const arrId = this.$route.params.id.split('-')
      return Number(arrId[0])
    },
    refuelingState() {
      return this.form.alertHi
    },
    fuelLossState() {
      return this.form.alertLo
    },
    refuelingStatePercent() {
      return this.refuelingState
        ? Number(this.form.alertHi) >= 1 && Number(this.form.alertHi) <= 100
        : true
    },
    fuelLossStatePercent() {
      return this.fuelLossState
        ? Number(this.form.alertLo) >= 1 && Number(this.form.alertLo) <= 100
        : true
    },
    isValidForm() {
      return (
        this.refuelingState &&
        this.fuelLossState &&
        this.refuelingStatePercent &&
        this.fuelLossStatePercent &&
        (this.form.alertHi != this.current.alertHi || this.form.alertLo != this.current.alertLo)
      )
    },
    title() {
      return this.$t('global.changeParameter')
    },
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.list.trackerSensor.trackerSensor'),
          to: { name: 'Setting Tracker & Sensor' },
        },
        {
          text: this.$t('setting.list.trackerSensor.fuel'),
          to: { name: 'Fuel Sensor Setting' },
        },
        {
          text: this.$t('global.changeParameter'),
          active: true,
        },
      ]
    },
    /**
     * Management Field for b-table
     */
  },
  methods: {
    submitForm() {
      this.$bvModal.show('mc-modal-confirm')
    },

    async confirmForm() {
      this.isUpdated = true
      this.$bvModal.hide('mc-modal-confirm')
      const input = {
        id: [this.$route.params.id],
        newData: {
          alertHi: Number(this.form.alertHi),
          alertLo: Number(-this.form.alertLo),
        },
      }

      const res = await this.$apollo.mutate({
        mutation: UPDATE_SENSOR_PAGINATED,
        variables: {
          input: input,
        },
      })
      const message = res.data.updateSensors.message
      this.isUpdated = false
      this.current.alertHi = this.form.alertHi
      this.current.alertLo = this.form.alertLo
      if (message == 'Successful') {
        this.$mcToast.success(this.$t('global.alert.text.changed'))
      } else {
        this.$mcToast.error(this.$t('global.alert.text.failChange'))
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="mc-page-three" />
    <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
      <div class="float-end">
        <McButton
          variant="secondary"
          class="mx-2"
          :text="$t('global.back')"
          icon="icon-outline_arrow-left"
          @click="$router.push({ name: 'Fuel Sensor Setting' })"
        />
      </div>
    </div>
    <h4 class="card-title">
      {{ $t('setting.list.trackerSensor.fleetInformation') }}
    </h4>
    <b-card class="mt-3 mb-5">
      <b-row class="mc-list-info__top">
        <b-col>
          <span>{{ $t('setting.list.trackerSensor.licensePlate') }}</span>
          {{ data.licensePlate ?? '-' }}
        </b-col>
        <b-col>
          <span>{{ $t('setting.list.trackerSensor.sensorType') }}</span>
          {{ data.sensorType ?? '-' }}
        </b-col>
        <b-col>
          <span>{{ $t('setting.list.trackerSensor.vehicleGroup') }}</span>
          {{ data.vgroups ?? '-' }}
        </b-col>
        <b-col>
          <span>{{ $t('setting.list.trackerSensor.vehicleCategory') }}</span>
          {{ data.fleetCategory ?? '-' }}
        </b-col>
      </b-row>
      <b-row class="mt-3 mc-list-info__top">
        <b-col>
          <span>{{ $t('setting.list.trackerSensor.vehicleType') }}</span>
          {{ data.fleetType ?? '-' }}
        </b-col>
      </b-row>
    </b-card>

    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">
          {{ $t('setting.list.trackerSensor.fuelSensorSettingTitle') }}
        </h4>
      </div>

      <div class="float-end">
        <McButton
          variant="secondary"
          class="mx-2"
          :text="$t('global.cancel')"
          icon="icon-outline_close"
          @click="$router.push({ name: 'Fuel Sensor Setting' })"
        />
        <McButton
          variant="primary"
          class="me-2"
          :disabled="isUpdated || !isValidForm"
          :text="$t('global.save')"
          icon="icon-outline_save"
          @click="submitForm"
        >
          <template #before-slot>
            <b-spinner v-if="isUpdated" small label="Small Spinner" />
          </template>
        </McButton>
      </div>
    </div>
    <b-card class="my-3">
      <FormulateForm v-model="form" @submit="submitForm">
        <b-row>
          <b-col sm="12" md="3">
            <FormulateInput type="group">
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="formulate-input-label mb-1">
                    {{ $t('setting.list.trackerSensor.refueling') }}
                  </label>
                  <a
                    v-b-tooltip.topleft
                    :title="`${$t('setting.list.trackerSensor.refuelingInfo')}`"
                  >
                    <i class="icon-outline_info" />
                  </a>
                </div>
              </template>
              <b-row>
                <b-col sm="12" md="6">
                  <FormulateInput
                    id="alertHi"
                    v-model="form.alertHi"
                    name="alertHi"
                    type="number"
                    suffix
                    :placeholder="$t('setting.list.trackerSensor.refueling')"
                    validation="^required"
                    :validation-messages="{
                      required: $t('global.validation.required'),
                      min: $t('setting.list.trackerSensor.validator.percentage'),
                      max: $t('setting.list.trackerSensor.validator.percentage'),
                    }"
                    min="1"
                    max="100"
                    validation-behavior="blur"
                    error-behavior="blur"
                  >
                    <template #suffix>
                      <div class="formulate-input-suffix">
                        <span>%</span>
                      </div>
                    </template>
                  </FormulateInput>
                </b-col>
                <b-col sm="12" md="6">
                  <FormulateInput id="alertHiLiter" v-model="alertHiLiter" suffix disabled>
                    <template #suffix>
                      <div class="formulate-input-suffix">
                        <span>{{ $t('global.unit.liter') }}</span>
                      </div>
                    </template>
                  </FormulateInput>
                </b-col>
              </b-row>
            </FormulateInput>
          </b-col>
          <b-col sm="12" md="3">
            <FormulateInput type="group">
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="formulate-input-label mb-1">
                    {{ $t('setting.list.trackerSensor.fuelLoss') }}
                  </label>
                  <a
                    v-b-tooltip.topleft
                    :title="`${$t('setting.list.trackerSensor.fuelLossInfo')}`"
                  >
                    <i class="icon-outline_info" />
                  </a>
                </div>
              </template>
              <b-row>
                <b-col sm="12" md="6">
                  <FormulateInput
                    id="fuelLoss"
                    v-model="form.alertLo"
                    name="alertLo"
                    :placeholder="$t('setting.list.trackerSensor.fuelLoss')"
                    suffix
                    type="number"
                    validation="^required"
                    :validation-messages="{
                      required: $t('global.validation.required'),
                      min: $t('setting.list.trackerSensor.validator.percentage'),
                      max: $t('setting.list.trackerSensor.validator.percentage'),
                    }"
                    min="1"
                    max="100"
                    validation-behavior="live"
                    error-behavior="live"
                  >
                    <template #suffix>
                      <div class="formulate-input-suffix">
                        <span>%</span>
                      </div>
                    </template>
                  </FormulateInput>
                </b-col>
                <b-col sm="12" md="6">
                  <FormulateInput id="alertLo" v-model="alertLoLiter" suffix disabled>
                    <template #suffix>
                      <div class="formulate-input-suffix">
                        <span>{{ $t('global.unit.liter') }}</span>
                      </div>
                    </template>
                  </FormulateInput>
                </b-col>
              </b-row>
            </FormulateInput>
          </b-col>
          <b-col sm="12" md="3">
            <FormulateInput
              id="fuelCapacity"
              name="fuelCapacity"
              :label="$t('setting.list.trackerSensor.tankCapacity')"
              suffix
              disabled
            >
              <template #suffix>
                <div class="formulate-input-suffix">
                  <span>{{ $t('global.unit.liter') }}</span>
                </div>
              </template>
            </FormulateInput>
          </b-col>
          <b-col sm="12" md="3">
            <FormulateInput
              id="rangeHi"
              name="rangeHi"
              :label="$t('setting.list.trackerSensor.fullTankLimit')"
              disabled
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="12" md="3">
            <FormulateInput
              id="rangeLo"
              name="rangeLo"
              :label="$t('setting.list.trackerSensor.emptyTankLimit')"
              disabled
            />
          </b-col>
        </b-row>
      </FormulateForm>
    </b-card>
    <b-modal
      id="mc-modal-confirm"
      class="mc-modal"
      :title="$t('setting.list.trackerSensor.changeFleet')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>{{ $t('global.updateConfirm') }}</p>
      </div>
      <template #modal-footer="{ cancel }">
        <McButton size="md" variant="secondary" :text="$t('global.action.no')" @click="cancel()" />
        <McButton
          size="md"
          variant="primary"
          :text="$t('global.action.yes')"
          @click="confirmForm"
        />
      </template>
    </b-modal>
  </Layout>
</template>
